import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { getErrorHandlingOptions } from '../base/headers';
import { ManufacturingOrderFeature } from '../../models/manufacturing-order-feature';
import { ManufacturingOrderFeatureBuilder } from '../../models/builders/manufacturing-order-feature.builder';

const manufacturingOrderFeatureBody = (manufacturingOrderFeature: ManufacturingOrderFeature) => ({
  name: manufacturingOrderFeature.name
});

@Injectable()
export class ManufacturingOrderFeatureApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }manufacturing-order-features`;
  }

  getManufacturingOrderFeatures() {
    return this.httpClient.get(`${ this.apiUrl }`, getErrorHandlingOptions())
      .pipe(
        map(ManufacturingOrderFeatureBuilder.fromList)
      );
  }

  getManufacturingOrderFeature(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(ManufacturingOrderFeatureBuilder.fromJson)
      );
  }

  createManufacturingOrderFeature(manufacturingOrderFeature) {
    const body = manufacturingOrderFeatureBody(manufacturingOrderFeature);
    return this.httpClient.post(this.apiUrl, body).pipe(map(ManufacturingOrderFeatureBuilder.fromJson));
  }

  updateManufacturingOrderFeature(manufacturingOrderFeature: ManufacturingOrderFeature) {
    // tslint:disable-next-line: max-line-length
    return this.httpClient.put(`${ this.apiUrl }/${ manufacturingOrderFeature.hash }`, manufacturingOrderFeatureBody(manufacturingOrderFeature));
  }

  deleteManufacturingOrderFeature(manufacturingOrderFeature: ManufacturingOrderFeature) {
    return this.httpClient.delete(`${ this.apiUrl }/${ manufacturingOrderFeature.hash }`);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/manufacturing-order-feature-api.service.ts